import { render, staticRenderFns } from "./DesmatamentoGfwParaguai.vue?vue&type=template&id=74810d66&lang=pug"
import script from "./DesmatamentoGfwParaguai.vue?vue&type=script&lang=js"
export * from "./DesmatamentoGfwParaguai.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports